module.exports = __webpack_public_path__ + "static/media/abaka.60f1c978.png";